<template>
  <div ref="registerEmailModal" class="modal fade" id="registerEmailModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Sign up to just bookmark it!</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div v-if="!formSubmitted" class="modal-body">

            <error-panel showInPopup="true" />

            <form @submit="registerEmail($event)" class="row-container" method="post">

            <p>Thank you for your interest in joining our growing community.
              The registration consists of 2 easy steps. </p>

            <ul class="list-unstyled">

              <li>
                <i class="bi bi-1-circle-fill text-success mr-2"></i>
                First we ask for your email address so that
                we can send you a registration link.
              </li>
              <li>
                <i class="bi bi-2-circle-fill text-success mr-2"></i>
                When you open that link, you'll be able to complete setting up your account
                and start your 3-day trial period.</li>
            </ul>

            <div class="form-label-group mb-3 required">
              <input id="email" name="email" type="text" class="form-control" v-model="email" />
              <label class="" for="email">Email:</label>
            </div>

            <div class="pt-2 custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="consentSwitch" v-model="consent"/>
              <label class="custom-control-label" for="consentSwitch">
                I accept the <a href="/terms-of-use" target="_blank">Terms of Use</a> and the
                <a href ="/privacy" target="_blank">Privacy Policy</a>
              </label>
            </div>

            <div class="row pt-3 pb-3">
              <div class="col-12 text-center">
                <spinner-button :spinning="submitInProgress"
                                buttonType="submit"
                                class="btn btn-cta btn-cta-large">Sign me up!
                </spinner-button>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12 text-center text-muted support-text">
                Can't sign up for some reason? Send us a mail at
                <i class="bi bi-envelope mr-1"></i>
                <a href="mailto:support@justbookmark.it">support@justbookmark.it</a>
              </div>
            </div>
          </form>

        </div>

        <div v-if="formSubmitted" class="modal-body">
          <p>Thank you!</p>
          <i class="bi bi-check-circle tl-check-icon"></i> You will soon receive a message about the next step at {{ email }}. Stay tuned!


          <div class="row pt-1">
            <div class="col-12">
              <button class="float-right btn btn-secondary" data-dismiss="modal" type="submit">Close</button>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
</template>
<script>
import BackendClient from "@/rest/backend-client";
import ErrorPanel from "@/components/ErrorPanel";
import SpinnerButton from "@/components/SpinnerButton";

export default {
  name: "RegisterEmailModal",
  components: {
    ErrorPanel, SpinnerButton
  },
  props: [''],
  data() {
    return {
      backendClient: new BackendClient(),
      formSubmitted: false,
      submitInProgress: false,
      email: "",
      consent: false,
    };
  },

  mounted() {
  },

  computed: {
  },

  methods: {
    registerEmail(event) {
        event.preventDefault();

        if (!this.consent) {
          this.$store.commit("addError", "Please accept the terms to sign up!");
          return;
        }

        if (!this.email || this.email === "") {
          this.$store.commit("addError", "Please add an email address!");
          return;
        }

        if (!this.email.trim().includes("@")) {
          this.$store.commit("addError", "Please add a valid email address!");
          return;
        }

        this.submitInProgress = true;
        this.backendClient.registerEmail(this.email.trim()).then(() => {
          this.formSubmitted = true;
        }).finally(() => { this.submitInProgress = false });
    }
  }
};
</script>
<style scoped>

</style>